import { render, staticRenderFns } from "./embedLayout.vue?vue&type=template&id=a98c7f76&scoped=true&"
import script from "./embedLayout.vue?vue&type=script&lang=js&"
export * from "./embedLayout.vue?vue&type=script&lang=js&"
import style0 from "./embedLayout.vue?vue&type=style&index=0&id=a98c7f76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c7f76",
  null
  
)

export default component.exports